import { render, staticRenderFns } from "./Orderby2.vue?vue&type=template&id=11ede5fe&scoped=true&"
import script from "./Orderby2.vue?vue&type=script&lang=js&"
export * from "./Orderby2.vue?vue&type=script&lang=js&"
import style0 from "./Orderby2.vue?vue&type=style&index=0&id=11ede5fe&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11ede5fe",
  null
  
)

export default component.exports